import {HTTP} from "@/http";

class FileStorageService {
  basePath = 'api/v2/admin/file-storage';

  /**
   * Upload a file to the server
   * @param {File} file - The file to upload
   * @returns {Promise<string>} - Promise that resolves to the URL of the uploaded file
   */
  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    return HTTP.post(`${this.basePath}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  /**
   * Delete a file from the server
   * @param {string} filename - The name of the file to delete
   * @returns {Promise<void>}
   */
  deleteFile(filename) {
    return HTTP.delete(`${this.basePath}/files/${filename}`);
  }
}

/**
 * @type {FileStorageService}
 */
export const fileStorageService = new FileStorageService();
